export function scrollCoordinates () {
  var doc = document.documentElement;
  var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

  return {left, top}
}


// WEBPACK FOOTER //
// ./lib/brave-utils/window.js